import { Injectable } from '@angular/core';
import { BaseService, UrlParam } from './classes/BaseService';
import { HttpClient } from '@angular/common/http';
import { Global } from './classes/Global';

@Injectable({
  providedIn: 'root'
})
export class ReferralService extends BaseService{

  apiUrl = "Referral.php?";

  constructor(protected http: HttpClient) {
    super(http);
  }

  inviteUser(email: string, sessionToken: string, country: string) {
    const url = this.serverUrl + this.apiUrl;
    const params = this.buildUrlParams(
      new UrlParam("country", country),
      new UrlParam("action", "inviteUser"),
      new UrlParam("email", email),
      new UrlParam("origin", "website"),
      new UrlParam("appEntity", Global.APP_ENTITY_MAIN_WEBSITE),
      new UrlParam("sessionToken", sessionToken)
    );
    return this.post(url, params);
  }

  remove(id: string, sessionToken: string, country: string) {
    const url = this.serverUrl + this.apiUrl;
    const params = this.buildUrlParams(
      new UrlParam("country", country),
      new UrlParam("action", "remove"),
      new UrlParam("id", id),
      new UrlParam("sessionToken", sessionToken)
    );
    return this.post(url, params);
  }

  resendInvitationMail(id: string, sessionToken: string, country: string) {
    const url = this.serverUrl + this.apiUrl;
    const params = this.buildUrlParams(
      new UrlParam("action", "resendInvitationMail"),
      new UrlParam("country", country),
      new UrlParam("id", id),
      new UrlParam("sessionToken", sessionToken)
    );
    return this.post(url, params);
  }

  getUserReferralData(sessionToken: string, country: string) {
    const url = this.serverUrl + this.apiUrl +
    this.buildUrlParams(
      new UrlParam("action", "getUserReferralData"),
      new UrlParam("country", country),
      new UrlParam("sessionToken", sessionToken)
    );
    return this.get(url);
  }

}
